<template>
  <div class="m3p-contact__input m3p-contact__carrier">
    <select
      class="m3p-select m3p-form__strong"
      id="experience_position_type"
      name="experience_position_type"
      v-model="selectorValue"
      @focus="event => emit('focus', event)"
      @blur="event => emit('blur', event)"
    >
      <option value disabled>選択してください</option>
      <option
        v-for="item in selectiveExperiencePositionTypeList"
        :value="item.code"
        :key="item.code"
        >{{ item.name }}</option
      >
    </select>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const emit = defineEmits(['change', 'focus', 'blur']);

const props = defineProps({
  selectiveExperiencePositionTypeList: {
    type: Array,
    required: true
  },
  experiencePositionType: {
    type: String,
    required: true
  }
});

const selectorValue = ref(props.experiencePositionType);

const changeValue = newValue => {
  emit('change', 'position_type', newValue);
};

const clearDefault = () => {
  if (
    !props.selectiveExperiencePositionTypeList.find(
      item => item.code === selectorValue.value
    )
  ) {
    selectorValue.value = null;
  }
};

watch(selectorValue, newValue => changeValue(newValue));

watch(
  () => props.selectiveExperiencePositionTypeList,
  () => {
    clearDefault();
  }
);

clearDefault();
</script>
